//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from '@/components/Footer.vue'
import TopNav from '@/components/TopNav.vue'

import { SHORT_MONTH_DAY_FORMAT } from '@/lib/constants'

import { formatDueDate, isDeviceMobile } from '@/lib/utils'
import { platforms } from '@/lib/platforms'
import { isUnlimited, isPaidPlan } from '@/lib/plans'

import { mapGetters, mapState } from 'vuex'

import inboxUnreadCounts from '@/graphql/queries/conversations/inboxUnreadCounts.gql'

let tourSteps = [
  {
    target: '[data-v-step="schedule"]',
    header: {
      title: 'Schedule Posts'
    },
    content:
      'Use the <strong>New Post</strong> button to schedule your posts from anywhere in Postpone.',
    params: {
      placement: 'right',
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="dashboard"]',
    header: {
      title: 'Dashboard'
    },
    content:
      'This is the <strong>Dashboard</strong>. All of your scheduled posts are displayed here.',
    params: {
      placement: 'right',
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="submissions"]',
    header: {
      title: 'History'
    },
    content:
      "After posts are submitted they'll appear under <strong>History</strong>. If posts fail to submit then they'll also be on this page.",
    params: {
      placement: 'right',
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="content-library"]',
    header: {
      title: 'Content Library'
    },
    content:
      'Use the <strong>Content Library</strong> to upload and reuse content. You can also edit images, add watermarks, organize content, and more.',
    params: {
      placement: 'right',
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="subreddit-manager"]',
    header: {
      title: 'Subreddit Manager'
    },
    content:
      'Use the <strong>Subreddit Manager</strong> to organize, label, and learn more about your favorite subreddits to submit posts to.',
    params: {
      placement: 'right',
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="analytics"]',
    header: {
      title: 'Analytics'
    },
    content:
      'Use <strong>Analytics</strong> to see how your posts are performing, which subreddits and content are most popular, and make better decisions for future posts.',
    params: {
      placement: 'right',
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="settings"]',
    header: {
      title: 'Settings'
    },
    content:
      'Change your account <strong>Settings</strong> here. You can change default post settings, configure notifications, and connect more social accounts.',
    params: {
      placement: 'right',
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="upgrade-account"]',
    header: {
      title: 'Postpone Plans'
    },
    content:
      "Check out <strong>Postpone's plans</strong> to schedule more posts, connect more accounts, and unlock powerful social media features.",
    params: {
      placement: 'bottom',
      highlight: true,
      enableScrolling: false
    }
  }
]

export default {
  name: 'Default',
  components: {
    'postpone-footer': Footer,
    'postpone-topnav': TopNav
  },
  data() {
    return {
      SHORT_MONTH_DAY_FORMAT,
      mobileNavOpen: false,
      inboxMenuOpen: false,
      callbacks: {
        onStart: this.onStart,
        onStop: this.onStop,
        onSkip: this.onSkip,
        onFinish: this.onFinish
      },
      inboxTourSteps: [
        {
          target: '[data-v-step="inbox"]',
          header: {
            title: 'Inbox'
          },
          content:
            "Nice! You just scheduled your first post! 🎉<br /><br />Reddit's algorithms like it when you reply to comments in addition to submitting posts. Here you'll find the <strong>Postpone Inbox</strong>, which includes every Reddit DM and reply on your posts.",
          params: {
            placement: 'right',
            highlight: true,
            enableScrolling: false
          },
          before: () =>
            new Promise((resolve, reject) => {
              this.inboxMenuOpen = true
              resolve()
            })
        },
        {
          target: '[data-v-step="replies"]',
          header: {
            title: 'Replies'
          },
          content:
            "This is the <strong>Replies Inbox</strong>. All replies to your posts will land here.<br /><br />Use the Inbox to track which comments you haven't yet replied to, send replies, and store saved replies (which you can use again and again).",
          params: {
            placement: 'right',
            highlight: true,
            enableScrolling: false
          },
          before: () =>
            new Promise((resolve, reject) => {
              this.$router.push({ path: '/posts/inbox' })
              resolve()
            })
        }
      ]
    }
  },
  apollo: {
    inboxUnreadCounts: {
      query: inboxUnreadCounts,
      skip() {
        return !this.isLoggedIn
      },
      result({ data }) {
        if (!data) {
          return
        }
        this.$store.commit(
          'totalUnreadCount',
          data.inboxUnreadCounts.totalUnreadCount
        )
      }
    }
  },
  methods: {
    formatDueDate,
    async handleLogoutClick() {
      await this.$store.dispatch('logout')
      this.$buefy.toast.open({
        message: 'Successfully logged out',
        type: 'is-info'
      })
      window.location.href = '/'
    },
    onStart() {
      this.$store.commit('startTour')
      this.$gtag.event('tutorial_begin')
    },
    onSkip() {
      this.$store.commit('finishTour')
      this.$router.push({ name: 'dashboard' })
    },
    onFinish() {
      this.$store.commit('finishTour')
      this.$gtag.event('tutorial_complete')
      this.$router.push({ name: 'dashboard' })
    },
    onStop() {
      this.$store.commit('finishTour')
      this.$router.push({ name: 'dashboard' })
    },
    collapseNav() {
      this.mobileNavOpen = false
    },
    hideConnectAccountButtons() {
      this.$prefs.showConnectAccountButtons = false
    }
  },
  computed: {
    ...mapState(['profile']),
    ...mapGetters([
      'isLoggedIn',
      'plan',
      'isConnectedToReddit',
      'hasPendingEmailConfirmation',
      'connectedPlatforms',
      'isConnectedToNonRedditPlatform',
      'totalAccounts'
    ]),
    submissionsPath() {
      if (this.connectedPlatforms.length === 0) {
        return '/submissions'
      } else {
        if (this.connectedPlatforms.includes(this.$prefs.platformDisplay)) {
          return `/submissions/${this.$prefs.platformDisplay}`
        } else {
          let platform = this.connectedPlatforms[0]
          return `/submissions/${platform}`
        }
      }
    },
    analyticsPath() {
      if (this.connectedPlatforms.length === 0) {
        return '/analytics'
      } else {
        if (this.connectedPlatforms.includes(this.$prefs.platformDisplay)) {
          return `/analytics/${this.$prefs.platformDisplay}`
        } else {
          let platform = this.connectedPlatforms[0]
          return `/analytics/${platform}`
        }
      }
    },
    displayConnectAccountButtons() {
      const platformConnections = platforms.map((platform) => {
        return this.$store.getters.isConnectedToPlatform(platform.code)
      })
      return (
        this.$prefs.showConnectAccountButtons &&
        platformConnections.filter((p) => p).length < 2
      )
    },
    enabledAndUnconnectedPlatforms() {
      return platforms.filter((platform) => {
        return (
          this.$store.getters.isPlatformFeatureEnabled(platform.code) &&
          !this.$store.getters.isConnectedToPlatform(platform.code)
        )
      })
    },
    displayRedditFeatures() {
      return (
        this.connectedPlatforms.length === 0 ||
        this.connectedPlatforms.includes('reddit')
      )
    },
    accountsWithoutHistoryEnabled() {
      if (!this.profile) {
        return []
      } else {
        return this.profile.redditAccounts.filter(
          (account) => !account.hasHistoryEnabled
        )
      }
    },
    hasUnlimitedPosts() {
      if (!this.profile) {
        return false
      } else {
        return isUnlimited(this.profile.account.allowedMonthlyPosts)
      }
    },
    shouldShowUpgradePlan() {
      if (!this.profile) {
        return false
      }
      return (
        this.plan.monthlyPrice === 0.0 ||
        this.$store.getters.monthlyPostUsagePercentage >= 0.8
      )
    },
    steps() {
      if (this.profile && isPaidPlan(this.profile.account.plan)) {
        return tourSteps.filter(
          (step) => step.target !== '[data-v-step="upgrade-account"]'
        )
      } else {
        return tourSteps
      }
    },
    hasUnreadMessages() {
      return this.$store.getters.totalUnreadCount > 0
    }
  },
  watch: {
    'profile.onboardingScheduledPost': function (value, oldValue) {
      if (
        oldValue === false &&
        value &&
        !isDeviceMobile() &&
        this.isConnectedToReddit
      ) {
        this.$tours['inboxTour'].start()
      }
    }
  }
}
